import {Component, Input, HostBinding, OnInit} from '@angular/core';
import {AppointmentService} from "../../services/appointment.service";
import {FeedbackDialogComponent, FeedbackType} from "../../pages/appointment/feedback-dialog/feedback-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {SessionService} from "../../services/session.service";

/** Simple floating button that will open up the in-app feedback window */
@Component({
  selector: 'app-feedback-button',
	imports: [
		MatIcon,
		MatIconButton
	],
  templateUrl: './feedback-button.component.html',
  styleUrl: './feedback-button.component.scss'
})
export class FeedbackButtonComponent implements OnInit {
	/** Type of feedback to show */
	@Input()
	type:FeedbackType;

	/** Is the nav bar hidden */
	@HostBinding('class.hidden')
	isHidden:boolean = true;

	/** Optional diagnosis code this is for */
	@Input()
	code?:string;

	constructor(private matDialog:MatDialog,
							private sessionService:SessionService) {
	}

	ngOnInit():void {
		this.isHidden = !this.sessionService.allaiUser.feedback_enabled;
	}

	/** Open the feedback dialog */
	openFeedbackDialog() {
		this.matDialog.open(FeedbackDialogComponent, {
			autoFocus: false,
			width: "668px",
			data: {
				type: this.type,
				code: this.code
			}
		});
	}
}
